<template lang="pug">
div(
  v-if="idProcesso"
)
  app-modal-visualizar-completo(
    v-if="visualizarProcesso && idProcesso !== null",
    @closeModal="visualizarProcesso = false",
    :idProcesso='idProcesso',
    :protocolo="protocolo",
    :tipo="tipoProcesso"
    :numeroProcesso="numeroProcesso",
  )
  app-modal-informacao(
    v-if="informacoes",
    :idProcesso="idProcesso"
    :idDespacho="idDespacho"
    :setor='setorSelecionado'
    :setHasInformacoa="setHasInformacoa"
    @closeModal="informacoes = false"
    @setHasInformacoa="setHasInformacoa"
  )
  app-modal-solicitar-retificacao(
    v-if="solicitarRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setorSelecionado'
    @closeModal="solicitarRetificacao = false"
  )
  app-modal-notificar-interessado(
    v-if="notificarInteressado",
    :idProcesso="idProcesso",
    :idDespacho="idDespacho",
    :isSubProcesso="isSubProcesso",
    @closeModal="closeModalNotificarInteressado",
    @updateHasConversa="updateHasConversa"
  )
  app-modal-legislacao(
    v-if="legislacao",
    @closeModal="legislacao = false"
  )
  app-modal-cancelar-retificacao(
    v-if="cancelarRetificacao",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :setor='setorSelecionado'
    @closeModal="cancelarRetificacao = false"
  )
  el-dropdown.margin-bottom(trigger='click')
    el-button(type='info', size="small")
      | Opções
      i.el-icon-arrow-down.el-icon--right
    el-dropdown-menu(slot='dropdown')
        el-dropdown-item(v-if="btnSolicitarInformacao && opcoesHeader")
          .flex(@click="informacoes = true")
            i.material-icons.color-informacao email
            span &nbsp {{ !hasInformcao ? 'Solicitar Informação' : 'Informação'}}
        div(v-if="btnRetificacao && opcoesHeader && processoRetificavel()")
          el-dropdown-item(v-if="enableButton('SOLICITAR_RETIFICACAO') && !isEmissaoCertidao")
            .flex(@click="solicitarRetificacao = true")
              i.material-icons.color-refresh.color-retificacao refresh
              span &nbsp Solicitar Retificação
        div(v-if="btnNotificarInteressado")
          el-dropdown-item(v-if="enableButton('NOTIFICAR_INTERESSADO')")
            .flex(@click="notificarInteressado = true")
              i.material-icons.color-mensagem sms
              span &nbsp {{ !hasConversa ? 'Notificar Interessado' : 'Mensagens'}}
        el-dropdown-item
          .flex(@click="visualizarProcesso = true")
            i.material-icons.color-visualizar-processo visibility
            span &nbsp Visualizar processo
        el-dropdown-item(v-if="conversaAberta && (isPa || isBa) ")
          .flex(@click="fecharConversa")
            i.material-icons.color-red close
            span &nbsp Fechar conversas
        el-dropdown-item(v-if="emRetificacao && !isPa")
          .flex(@click="cancelarRetificacao = true")
            i.material-icons.color-red close
            span &nbsp Cancelar Retificação
        el-dropdown-item(v-if="EXIBIR_CONSULTA_LEGISLACAO")
          .flex(@click="legislacao = true")
            i.material-icons search
            span &nbsp Legislação
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from '@/utils/api'
import AppModalNotificarInteressado from '@/screens/analise/components/modal/AppModalNotificarInteressado'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
import AppModalInformacao from '@/screens/analise/components/modal/AppModalInformacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalLegislacao from '@/screens/analise/components/modal/AppModalLegislacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModalNotificarInteressado,
    AppModalSolicitarRetificacao,
    AppModalInformacao,
    AppModalVisualizarCompleto,
    AppModalLegislacao,
    AppModalCancelarRetificacao
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      visualizarProcesso: false,
      informacoes: false,
      solicitarRetificacao: false,
      cancelarRetificacao: false,
      notificarInteressado: false,
      legislacao: false,
      cadastro: {},
      processo: {},
      isPossuiTitulo: true,
      selected: 'analise',
      hasConversa: false,
      tituloInformacao: '',
      setorSelecionado: null,
      setorCodigo: null,
      hasInformcao: false,
      idUsuario: null,
      conversaAberta: false,
      isPa: process.env.ESTADO === 'pa',
      isBa: process.env.ESTADO === 'ba'
    }
  },

  computed: {
    ...mapState({
      EXIBIR_CONSULTA_LEGISLACAO: state => state.userInterface.dadosEstado.ANALISE.EXIBIR_CONSULTA_LEGISLACAO
    })
  },

  props: {
    idProcesso: {
      required: true
    },
    numeroProcesso: {
      required: true
    },
    tipoProcesso: {
      required: false
    },
    protocolo: {
      required: false
    },
    idDespacho: {
      required: false
    },
    btnSolicitarInformacao: {
      default: true
    },
    btnRetificacao: {
      default: true
    },
    btnNotificarInteressado: {
      default: true
    },
    opcoesHeader: {
      default: true
    },
    isEmissaoCertidao: {
      required: false
    },
    isSubProcesso: {
      default: false
    },
    emRetificacao: {
      default: false
    }
  },

  async created () {
    const user = await this.getUsuario()
    this.getConversaPerdidaPendente()
    this.idUsuario = user.id
    this.setorSelecionado = user.perfilSelecionado.setor.codigo
    this.setorCodigo = user.perfilSelecionado.codigo
    await this.getConversa()
    if (this.btnSolicitarInformacao) {
      await this.updateHasInformacao()
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      hasConversaByProcesso: 'conversa/hasConversaByProcesso',
      encerraConversaPendente: 'conversa/encerraConversaPendente'
    }),
    async getConversa () {
      const obj = {
        idUsuario: this.idUsuario,
        idProcesso: this.idProcesso,
        tipoMensagem: 'NOTIFICACAO_INTERESSADO'
      }
      this.hasConversa = await this.hasConversaByProcesso(obj)
    },
    async getConversaPerdidaPendente () {
      axios({
        method: 'GET',
        url: `conversa/processo/${this.idProcesso}/solicitacao/aberta`
      })
        .then((existe) => {
          this.conversaAberta = existe
        })
    },
    fecharConversa () {
      this.confirmBox(this.$messages.CONFIRMA_FECHAR_CONVRSA_EM_ABERTO, this.$messages.TITULO_WARNING, () => {
        axios({
          method: 'GET',
          url: `conversa/processo/${this.idProcesso}/fechar/aberta/pendente/38bb1631-4173-439e-8c25-aa85183c664c`
        })
          .then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'Conversas encerradas!'
            )
            this.conversaAberta = false
          })
      })
    },
    updateHasConversa (value) {
      this.hasConversa = value
    },
    closeModalNotificarInteressado () {
      this.notificarInteressado = false
    },

    processoRetificavel () {
      if (this.tipoProcesso === null) {
        return true
      } else {
        switch (this.tipoProcesso) {
          case 'INFORMACOES':
          case 'PERMUTA':
          case 'PEAS_FILHO':
          case 'AFORAMENTO':
          case 'TRANSFERENCIA_DIREITOS':
          case 'AREAS_PATRIMONIAIS':
            return false
          default:
            return true
        }
      }
    },

    enableButton (buttonName) {
      var result = false

      switch (buttonName) {
        case 'NOTIFICAR_INTERESSADO':
          result = regrasAnalise.notificarInteressado.perfis.includes(this.setorCodigo)
          break

        case 'SOLICITAR_RETIFICACAO':
          if (this.tipoProcesso !== 'REGULARIZACAO_URBANA' && !this.emRetificacao) {
            result = regrasAnalise.solicitarRetificacao.perfis.includes(this.setorCodigo)
            break
          }
      }
      return result
    },

    setHasInformacoa (isInformacao) {
      this.hasInformcao = isInformacao
    },

    async updateHasInformacao () {
      let data = await axios({
        method: 'GET',
        url: `solicitarInformacao/processo/${this.idProcesso}/setor/${this.setorSelecionado}`,
        error: true
      })
      this.hasInformcao = !!data.length > 0
    }
  }
}
</script>

<style scoped lang="scss">
.label {
  font-weight: bold;
  color: #424242;
}

.margin-bottom {
  margin-bottom: 5px;
}

.color-retificacao {
  color: #f3a530;
}

.color-informacao {
  color: #104f55;
}

.color-mensagem {
  color: #01baef;
}

.color-visualizar-processo {
  color: #23a573;
}

.color-red {
  color: #D32F2F ;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: left;
}

.titulo-analise {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: solid 1px #e6e6e6;
}

.center {
  display: flex;
  align-items: center;
}

.color {
  background-color: #104f55;
  border: solid #104f55 1px;
}

.btn {
  padding: 7px;
  margin-bottom: 10px;
}

.icon {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/components/AppOpcoesHeaderAnalise.vue